<template>

  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        
        <el-form-item label="">
          <el-input v-model="formInline.title" placeholder="请输入会员的昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="back">返回上一页</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="avatarUrl" label="用户头像" >
               <template slot-scope="scope">
                <div v-if="scope.row.avatarUrl">
                  <img :src="scope.row.avatarUrl" width="30px" height="30px" />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="nickName" label="用户昵称" ></el-table-column>
            <!-- <el-table-column prop="status_text" label="活动状态" width="120"></el-table-column> -->
            <el-table-column prop="create_time" label="浏览时间" ></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      activity_id:0,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未开始', '进行中', '已结束'],
    };
  },
  created() {
    this.activity_id = this.$route.query.activity_id;
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.activity_id = self.activity_id;
      self.loading = true;
      activityApi.browseRecord(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /* 活动详情 */
    detailClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/activity/activity/detail',
        query: {
          activity_id: activity_id
        }
      });
    },

    /* 浏览记录 */
    browseClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/activity/activity/browse',
        query: {
          activity_id: activity_id
        }
      });
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/activity/activity/add');
    },

    /*编辑活动*/
    editClick(row) {
      let activity_id = row.activity_id;
      this.$router.push({
        path: '/plus/activity/activity/edit',
        query: {
          activity_id: activity_id
        }
      });
    },
    back(){
       this.$router.push({
        path: '/plus/activity/index'
      });
    },
    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          activityApi.delActivity(
            {
              activity_id: row.activity_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/browse.vue